import { motion } from "framer-motion";

export const Footer = () => (
  <footer
    className="border-t border-white/10 px-6 md:px-12 pt-32 pb-12 bg-coal"
    data-testid="main-footer"
  >
    <motion.a
      href="#contact"
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
      className="block font-serif text-[13vw] md:text-[9vw] leading-none tracking-tighter text-hollow hover:text-bone transition-colors duration-1000 whitespace-nowrap"
      data-testid="footer-cta"
    >
      contactez-nous
    </motion.a>

    <div className="grid md:grid-cols-3 gap-12 mt-32 mb-24">
      <div>
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Brauer Élémentaire</p>
        <p className="text-sm text-ash font-light leading-relaxed">
          Valréas — Vaucluse
          <br />
          Interventions à domicile
        </p>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Écrire</p>
        <a
          href="mailto:brauerelementaire@gmail.com"
          data-testid="footer-email"
          className="text-sm text-ash font-light hover:text-bone transition-colors duration-500"
        >
          brauerelementaire@gmail.com
        </a>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Appeler</p>
        <div className="flex gap-8">
          <a
            href="tel:+33760405373"
            data-testid="footer-phone"
            className="text-sm text-ash font-light hover:text-bone transition-colors duration-500"
          >
            07 60 40 53 73
          </a>
        </div>
      </div>
    </div>

    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-white/10">
      <p className="text-xs text-ash tracking-[0.2em]">© 2026 Brauer Élémentaire — Tous droits réservés</p>
      <div className="flex items-center gap-8">
        <a
          href="/mentions-legales"
          data-testid="footer-legal-link"
          className="text-xs text-ash tracking-[0.2em] hover:text-bone transition-colors duration-500"
        >
          Mentions légales
        </a>
        <a
          href="/admin"
          data-testid="footer-admin-link"
          className="text-xs text-ash tracking-[0.2em] hover:text-bone transition-colors duration-500"
        >
          Espace pro
        </a>
        <p className="text-xs text-ash tracking-[0.2em]">Valréas et les alentours</p>
      </div>
    </div>
  </footer>
);
